module.exports = __webpack_public_path__ + "img/favourites-background.4b285149.png";